import Expandable from "../../../../components/shared/Expandable";

const UpgradeNotes = ({ data }) => (
  <Expandable defaultOpened={false} title="Upgrade Notes">
    <p className="break-spaces">{data}</p>
  </Expandable>
);

export default UpgradeNotes;
